import { Logo } from "@/components/RoquaLogo";

export function DialogPageLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center overflow-y-auto bg-slate-200">
      <div className="flex flex-col bg-white px-4 py-8 shadow-sm sm:w-full sm:max-w-xl sm:rounded-lg sm:px-10">
        <Logo className="h-32" />
        <div className="mt-8 text-center text-xl">{children}</div>
      </div>
    </div>
  );
}
